// @ts-nocheck
import React, { useEffect, useState } from 'react';
import Router from 'next/router';
import { Box, Flex } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';
import SettingsMenu from '@/components/settings/menu';
import SmartImportWizard from '@/components/import-wizard/SmartImportWizard';
import * as Enums from '@/utils/enums';
import Storage from '@/utils/storage';
import Helper from '@/utils/helper';

function readDraftID(): string | null {
  if (typeof window === 'undefined') return null;
  return new URLSearchParams(window.location.search).get('draftId');
}

function writeDraftID(draftID: string | null) {
  if (typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  if (draftID) url.searchParams.set('draftId', draftID);
  else url.searchParams.delete('draftId');
  window.history.replaceState({}, '', url.toString());
}

function SmartImportPage() {
  let currPath = '';
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const [draftID] = useState<string | null>(readDraftID);
  const [accessStatus, setAccessStatus] = useState<any>(Enums.AccessStatus.None);

  useEffect(() => {
    const subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) setAccessStatus(subscriptionInfo.AccessStatus);
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, '/');
    }
  }, [accessStatus]);

  return (
    <div className="settings-container">
      <Flex justify="space-between">
        <SettingsMenu urlPath={currPath} />
        <Box w="100%" miw={0} style={{ overflow: 'hidden' }}>
          <SmartImportWizard draftID={draftID} onDraftChange={writeDraftID} />
        </Box>
      </Flex>
    </div>
  );
}

export default SmartImportPage;

export const Route = createFileRoute('/_authenticated/settings/import/smart')({ component: SmartImportPage });
